import React, { Component } from 'react';

class Feature2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            feature: [
                {
                    id: 1,
                    icon: 'bi bi-badge2',
                    title: 'Save More',
                    text: 'Salaried individuals can save thousands of rupees every year'
                },
                {
                    id: 2,
                    icon: 'bi bi-article',
                    title: 'Professionals Planning',
                    text: 'Professionals planning their finances smartly.'
                },
                {
                    id: 3,
                    icon: 'bi bi-headset',
                    title: 'Make The Most',
                    text: 'Wanting to make the most of their hard-earned money.'
                }
            ]
        }
    }

    render() {
        return (
            <section className="feature-2 pt-100 dark-bg-light">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-6">
                            <div className="section-heading center-heading text-center mb-60">
                                <h3 className="heading-title">Discover the Secret to Saving More on Your Taxes!</h3>
                                <p>Are you a salaried individual struggling with high tax deductions from your hard-earned income? Imagine being able to save thousands of rupees every year without breaking a sweat!</p>
                            </div>
                        </div>
                    </div>
                    <div className="row ">
                        {
                            this.state.feature.map((data) => (
                                <div className="col-lg-4 col-md-6">
                                    <div className="feature-style-2 mb-4 mb-lg-0" key={data.id} >
                                        <i className={data.icon}></i>
                                        <div className="feature-text">
                                            <h4>{data.title}</h4>
                                            <p>{data.text}</p>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }

                    </div>
                </div>
            </section>
        );
    }
}

export default Feature2;
